export default __webpack_public_path__ + "static/media/11.15.24 Minutes of the Regular Meeting of the BOD.c9cfcd26.pdf";